import React, { useEffect, useState } from "react";
import Logo from "../assets/logo/header-logo.svg";
import { Select } from "antd";
import RuFlag from "../assets/icons/ru-flag.svg";
import UsFlag from "../assets/icons/us-flag.svg";
import SpFlag from "../assets/icons/spanish-flag.svg";
import PtFlag from "../assets/icons/port-flag.svg";
import TrFlag from "../assets/icons/trt-flag.svg";
import ConnectionIcon from "../assets/icons/connection-icon.svg";
import i18n from "../translation/i18n";
import CompleteModal from "../components/CompleteModal";

type LanguageOption = {
  value: string;
  label: JSX.Element;
};

const allLanguages = [
  {
    value: "RU",
    label: (
      <div className="flag-content">
        <img src={RuFlag} width="22" alt="icon" />
        <span>RU</span>
      </div>
    ),
  },
  {
    value: "EN",
    label: (
      <div className="flag-content">
        <img src={UsFlag} width="22" alt="icon" />
        <span>EN</span>
      </div>
    ),
  },
  {
    value: "ES",
    label: (
      <div className="flag-content">
        <img src={SpFlag} width="22" alt="icon" />
        <span>ES</span>
      </div>
    ),
  },
  {
    value: "PT",
    label: (
      <div className="flag-content">
        <img src={PtFlag} width="22" alt="icon" />
        <span>PT</span>
      </div>
    ),
  },
  {
    value: "TR",
    label: (
      <div className="flag-content">
        <img src={TrFlag} width="22" alt="icon" />
        <span>TR</span>
      </div>
    ),
  },
];

function WebHeader({ address, chainId, isConnected, open, status }: any) {
  const getDefaultLang = (): string => {
    const saved = localStorage.getItem("lang");
    if (saved) return saved;

    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith("ru")) return "RU";
    if (browserLang.startsWith("es")) return "ES";
    if (browserLang.startsWith("pt")) return "PT";
    if (browserLang.startsWith("tr")) return "TR";
    return "EN"; // по умолчанию
  };

  const [language, setLanguage] = useState<string>(getDefaultLang());
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  useEffect(() => {
    // 1. Проверяем сохранённый язык
    const savedLang = localStorage.getItem("lang");

    // 2. Если нет — берём из браузера
    const browserLang = navigator.language.split("-")[0].toUpperCase();

    // 3. Проверяем, есть ли такой язык у нас
    const availableLangs = allLanguages.map((lang) => lang.value);
    const initialLang =
      savedLang && availableLangs.includes(savedLang)
        ? savedLang
        : availableLangs.includes(browserLang)
          ? browserLang
          : "EN"; // fallback

    setLanguage(initialLang);
    i18n.changeLanguage(initialLang);
    localStorage.setItem("lang", initialLang);
  }, []);

  const handleChangeLanguage = (value: string) => {
    setLanguage(value);
    localStorage.setItem("lang", value);
    i18n.changeLanguage(value);
  };


  const handleConnect = async () => {
    if (!isConnected) {
      await open();
    }
  };

  const handleDisconnect = () => {
    if (isConnected) {
      open();
    }
  };

  return (
    <div className="web_header">
      <img src={Logo} alt="logo" width={112} height={64} />
      <div className="header_right">
        <Select
          value={language}
          onChange={handleChangeLanguage}
          options={allLanguages}
          rootClassName="language-select"
        />
        {/* {!isConnected ? (
          <div className="header_right__connect-btn" onClick={handleConnect}>
            <img src={ConnectionIcon} alt="icon" width={24} height={24} />
          </div>
        ) : (
          <div className="wallet-address-btn" onClick={handleDisconnect}>
            <span>{address?.slice(0, 5) + "..." + address?.slice(-5)}</span>
          </div>
        )} */}
      </div>
      <CompleteModal
        infoModalOpen={infoModalOpen}
        setInfoModalOpen={setInfoModalOpen}
        errorTitle
        errorContent
        isError
      />
    </div>
  );
}

export default WebHeader;
